module.exports = $cash;